import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { LoadingSpinner } from "../AuthPage";
import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";

export const VerifyEmail = () => {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const Auth = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await axios.post(`https://dealersonly.parts/beta/api/sendResetEmail`, {
        email: email,
      });
      setIsLoading(false);
      setEmailSent(true);
    } catch (error) {
      setMsg(error.response.data);

      setIsLoading(false);
    }
  };

  const html = document.getElementsByTagName("html")[0];
  useEffect(() => {
    html.classList.remove("bg-gray-100");
    html.classList.add("bg-white");
  }, []);

  return (
    <>
      <div className="flex min-h-full items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-md space-y-8">
          <div>
            <img
              className="mx-auto h-24 w-auto"
              src="https://dealersonly.parts/beta/app/files/abujo.jpg"
              alt="D.O.P.E by Abujo Trading"
            />
            <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
              Dealers Only Parts E-Commerce
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600">
              Jetzt anmelden{" "}
              <Link
                to={"/register"}
                className="font-medium text-indigo-600 hover:text-indigo-500"
              >
                oder Benutzerkonto erstellen.
              </Link>
            </p>
          </div>
          {msg && (
            <div className="rounded-md bg-yellow-50 p-4 mb-1">
              <div className="flex">
                <div className="flex-shrink-0">
                  <ExclamationTriangleIcon
                    className="h-5 w-5 text-yellow-400"
                    aria-hidden="true"
                  />
                </div>
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-yellow-800">{msg}</h3>
                </div>
              </div>
            </div>
          )}
          {emailSent && (
            <div className="rounded-md bg-green-50 p-4 mb-1">
              <div className="flex">
                <div className="flex-shrink-0">
                  <ExclamationTriangleIcon
                    className="h-5 w-5 text-green-400"
                    aria-hidden="true"
                  />
                </div>
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-green-800">
                    Eine E-Mail zum Zurücksetzen des Passworts wurde gesendet.
                  </h3>
                </div>
              </div>
            </div>
          )}
          <form className="mt-8 space-y-6" onSubmit={Auth}>
            <input type="hidden" name="remember" defaultValue="true" />
            <div className="-space-y-px rounded-md shadow-sm">
              <div>
                <label htmlFor="email-address" className="sr-only">
                  Email
                </label>
                <input
                  id="email-address"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  className="relative block w-full appearance-none rounded-none rounded-t-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="group relative flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                {isLoading ? <LoadingSpinner /> : "Verify Email"}
              </button>
            </div>
          </form>
          <div className="w-full text-end ">
            Remember Password?{" "}
            <Link to="/login" className="">
              Login
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
